__turbopack_context__.v({
  "blocksBackgroundColor": "MessageBlock-module-scss-module__oN7ClW__blocksBackgroundColor",
  "blocksFontColor": "MessageBlock-module-scss-module__oN7ClW__blocksFontColor",
  "editor": "MessageBlock-module-scss-module__oN7ClW__editor",
  "messageBlock": "MessageBlock-module-scss-module__oN7ClW__messageBlock",
  "messageBlockEditable": "MessageBlock-module-scss-module__oN7ClW__messageBlockEditable",
  "messageContainer": "MessageBlock-module-scss-module__oN7ClW__messageContainer",
  "secondaryNavBackgroundColor": "MessageBlock-module-scss-module__oN7ClW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "MessageBlock-module-scss-module__oN7ClW__themeBackgroundColor",
  "themeFontColor": "MessageBlock-module-scss-module__oN7ClW__themeFontColor",
  "themeFontFamily": "MessageBlock-module-scss-module__oN7ClW__themeFontFamily",
  "viewBtn": "MessageBlock-module-scss-module__oN7ClW__viewBtn",
});
